import React, { useEffect, useState, useRef, createRef } from "react";
import { withRouter, useHistory, Link } from "react-router-dom";
import style from "./variantList.module.scss";
import Searchbar from "../productSearchbar/productSearchbar";
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Pagination from "../pagination/pagination";
import MobilePagination from "../mobilePagination/mobilePagination"
import Progressbar from "../progressbar/progressbar";
import Button from "../../Components/Button/button";
import Toast from "../Toast/Toast";
import SuccessToast from "../Toast/Toast"
import toPersianNumber from '../../helpers/actions/toPersianNumber';
import toEnglishNumber from "../../helpers/actions/toEnglishNumber";
import disconnectTextGenerator from "../../helpers/actions/disconnectedText"
import ImportVariantModal from '../importVariantModal/importVariantModal'
import GradientToast from "../gradientToast/Toast"
import {
    CalcPrice, GetBrands, GetproductGroup, GetProductListFromDK, GetProgressbarData, GetSingleVariant,
    GetSellers, GetVariantList, EditSingleVariantModalCalc, SubmitAddChannel, CompleteProgressBar, GetProgressBar
} from "../../actions/APIcalls";
import FiltersWrapper from "./variantFilters/variantFilters"
import MobileFilters from "../pricing/mobileFilters/mobileFilters"
import VariantWrapper from "./variantCardWrapper/variantCardWrapper";
import MobileVariantCard from "./mobileVariantCard/mobileVariantCard"
import VariantModalRenderer from "./variantModalRenderer/variantModalRenderer";
import EditModal from "../pricing/editModal/EditModal2";
import ChangeRouteModal from "../changeRouteModal/Modal"
import Skeleton from "./skeleton"
import EditChannelModal from "../editChannelModal/editChannelModal";
import noChannelEmptyState from '../../assets/icons/EmptyStates/variant_nochannel.svg'
import noVariantEmptyState from '../../assets/icons/EmptyStates/variant_noactivevariant.svg'
import noResultEmptyState from '../../assets/icons/EmptyStates/variant_noresult.svg'
import GeneralWarning from "../generalWarning/warning"


const VariantList = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(true)
    const [tempEditList, setTempEditList] = useState([])
    const [editModal, setEditModal] = useState({
        show: false
    })
    const [successToast, setSuccessToast] = useState({ text: '', value: false, type: 'success' })
    const [locationKeys, setLocationKeys] = useState([])
    const history = useHistory()

    // handle back and forward 
    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'PUSH') {
                setLocationKeys([location.key])
            }
            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    // Handle forward event
                    checkChange();
                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    // Handle back event
                    checkChange();
                }
            }
        })
    }, [locationKeys,])
    // end handle back and forward 

    useEffect(() => {
        getProgressbar();
    }, [])
    const [updateThreshold, setUpdateThreshold] = useState(0);

    let intervalRef = useRef();
    const countUp = () => setUpdateThreshold((prev) => prev + 1);
    useEffect(() => {
        intervalRef.current = setInterval(countUp, 1000);
        return () => clearInterval(intervalRef.current);
    }, []);
    useEffect(async () => {
        if (updateThreshold % 30 === 0) {
            let progressbarDataTemp = { ...progressbar };
            const resGetProgressbarData = await GetProgressbarData(openToast);
            // get variants at first and last time
            if (updateThreshold == 0 || resGetProgressbarData.data.percent == 100) {
                getVariants();
            }
            if (resGetProgressbarData.data.percent >= 100) {
                setSuccessToast({ ...successToast, text: 'تنوع‌های شما با موفقیت به‌روز رسانی شد', value: true, type: 'success' })
            }
            progressbarDataTemp = Object.assign(progressbarDataTemp, resGetProgressbarData.data);
            progressbarDataTemp.timer = 0;
            if (!(resGetProgressbarData.data.percent < 100 && resGetProgressbarData.data.AllVariantsCount > 0)) {
                clearInterval(intervalRef.current);
            }
            setProgressbar(progressbarDataTemp);
        } else {
            setTimeout(() => {
                let progressbarDataTemp = { ...progressbar };
                progressbarDataTemp.timer++;
                setProgressbar(progressbarDataTemp);
                progressbarDataTemp.remainTime > 0 ? progressbarDataTemp.remainTime - progressbar.timer <= 0 ? setUpdateThreshold(0) : console.log() : console.log();
            })
        }
    }, [updateThreshold]);


    const [progressbar, setProgressbar] = useState({ timer: 0 });

    const getProgressbar = async () => {
        let resProgressbarData = await GetProgressbarData(openToast);
        await getVariants();
        if (variantList.variantList.length > 0) {
            await getFilterData();
        } else {
            let channels = await GetSellers()
            if (channels && channels.data && channels.data.channelList) {
                let tmp = filterData
                tmp.channels = channels.data.channelList
                setFilterData({ ...tmp })
            }
        }
        let tmp = resProgressbarData.data
        tmp.timer = 0
        setProgressbar({ ...tmp });
    }

    const getFromUrl = (param) => {
        const defaultParams = {
            incompleteProducts: false,
            salesStatus: "none",
            newProduct: "nemidonam",
            brand: [],
            channel: [],
            productGroup: [],
            hasComp: "none",
            countInPage: 10,
            page: 1,
            query: ""
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (param === "brand" || param === "productGroup" || param === "channel") {
                return url.get(param).split("*");
            } else {
                if (url.get(param) === "true" || url.get(param) === "false") {
                    return url.get(param) === "true" ? true : false;
                } else {
                    return url.get(param)
                }
            }
        } else {
            return defaultParams[param];
        }
    }

    const pageSetter = number => {
        setToUrl(number, 'page')
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        if (param != "salesStatus" && param != "productGroup" && param != "brand" && param != "channel" && param != 'hasComp') {
            getVariants();
        }
    }
    const deleteFromUrl = (param) => {
        let url = new URLSearchParams(window.location.search);
        url.delete(param);
        props.history.push(window.location.pathname + "?" + url.toString());
        let filterDataTemp = { ...filterData };
        filterDataTemp[`${param}s`] = urlChecker(filterDataTemp[`${param}s`], param);
        setFilterData(filterDataTemp);
    }
    const checkUrl = () => {
        let result = false;
        const defaultParams = {
            incompleteProducts: false,
            salesStatus: "none",
            hasComp: "none",
            brand: [],
            channel: [],
            productGroup: []
        }
        const check = ["incompleteProducts", "salesStatus", "brand", "channel", "productGroup", "hasComp"]
        check.map(filter => {
            if (Array.isArray(getFromUrl(filter))) {
                if (getFromUrl(filter).length > 0) {
                    result = true;
                }
            } else {
                if (getFromUrl(filter) != defaultParams[filter]) {
                    result = true;
                }
            }
        })
        return result
    }
    const deleteAllFiletrs = () => {
        const check = ["incompleteProducts", "salesStatus", "channel", "productGroup", "brand", "hasComp"]
        let url = new URLSearchParams(window.location.search);
        let filterDataTemp = { ...filterData };
        check.map(filter => {
            url.delete(filter);
            props.history.push(window.location.pathname + "?" + url.toString());
            if (filter != 'hasComp' && filter != "salesStatus") {
                filterDataTemp[`${filter}s`] = urlChecker(filterDataTemp[`${filter}s`], filter);
            }
        })
        setFilterData(filterDataTemp);
        getVariants();
    }
    const checkChange = () => {
        const check = ["incompleteProducts", "salesStatus", "channel", "productGroup", "brand", "hasComp"]
        let filterDataTemp = { ...filterData };
        check.map(filter => {
            filterDataTemp[`${filter}s`] = urlChecker(filterDataTemp[`${filter}s`], filter);
        })
        setFilterData(filterDataTemp);
        getVariants();
    }

    const [variantList, setVariantList] = useState({ variantList: [] });
    const [importData, setImportData] = useState(false)
    const [isCalculatingPrice, setIsCalculatingPrice] = useState(false)
    const getVariants = async () => {
        setHasSkeleton(true)
        const params = {
            incompleteProducts: getFromUrl("incompleteProducts"),
            salesStatus: getFromUrl("salesStatus"),
            hasComp: getFromUrl("hasComp"),
            brand: getFromUrl("brand"),
            channel: getFromUrl("channel"),
            productGroup: getFromUrl("productGroup"),
            countInPage: getFromUrl("countInPage"),
            page: getFromUrl("page"),
            query: getFromUrl("query")
        }
        await params.salesStatus === "none" || params.salesStatus === "both" ? delete params.salesStatus : console.log();
        await params.hasComp === "none" || params.hasComp === "both" ? delete params.hasComp : console.log();
        let resVariants = await GetVariantList(params, openToast);
        let editVaraintTemp = { ...editVaraint };
        editVaraintTemp.variantIds = [];
        editVaraintTemp.variantIdsType = "none";
        setEditVaraint(editVaraintTemp);
        if (typeof resVariants !== 'undefined' && resVariants.data) {
            let tmpList = variantList
            tmpList.variantList = resVariants.data.variantList
            tmpList.variantCount = resVariants.data.variantCount
            tmpList.variantListPageCount = resVariants.data.variantListPageCount
            tmpList.hasChannel = resVariants.data.hasChannel
            setVariantList({ ...tmpList });
        }
        setHasSkeleton(false)
    }
    const [filterData, setFilterData] = useState({ brands: [], productGroups: [], channels: [] });
    const getFilterData = async () => {
        const resBrands = await GetBrands(openToast);
        const resChannels = await GetSellers(openToast);
        const resGroupProduct = await GetproductGroup(openToast);
        setFilterData({
            brands: urlChecker(resBrands.data.BrandList, "brand"),
            productGroups: urlChecker(resGroupProduct.data.GroupList, "productGroup"),
            channels: urlChecker(resChannels.data.channelList, "channel"),
        })
    }

    const divHeight = useRef();
    const [selectedFilters, setSelectedFilters] = useState({})
    const [showMoreFilters, setShowMoreFilters] = useState(false)

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    useEffect(() => {
        setShowFilters('showLess')
    }, [filterData])

    const setShowFilters = (type) => {
        let tempBoolean = false
        if (type == 'showMore') {
            tempBoolean = true
            setShowMoreFilters(!showMoreFilters)
        }
        let tmpString = ''
        let tmpsSelected = { brands: [], productGroups: [], channels: [], salesStatus: [], hasComp: [] }
        Object.keys(tmpsSelected).map(function (key, index) {
            if (filterData[key]) {
                filterData[key].map(item => {
                    if (item.checked) {
                        if (typeof tmpsSelected[key] != 'undefined') {
                            tmpString = tmpString + 'گروه کالا: ' + item.name
                            if (tmpString.length < 120) {
                                tmpsSelected[key].push(item)
                            } else {
                                if (tempBoolean) {
                                    tmpsSelected[key].push(item)
                                }
                            }
                        }
                    }
                })
            } else {
                if (key == 'salesStatus' || key == 'hasComp') {
                    let urlFilter = getFromUrl(key)
                    let tmpObject = null
                    switch (urlFilter) {
                        case 'none':
                            tmpsSelected[key] = []
                            break;
                        case 'both':
                            tmpString = tmpString + 'گروه کالا: ' + 'غیر فعال' + 'گروه کالا: ' + 'فعال'
                            tmpObject = { name: 'فعال و غیر فعال', checked: true }
                            break;
                        case true:
                            tmpString = tmpString + 'گروه کالا: ' + 'فعال'
                            tmpObject = { name: 'فعال', checked: true }
                            break;
                        case false:
                            tmpString = tmpString + 'گروه کالا: ' + 'غیر فعال'
                            tmpObject = { name: 'غیر فعال', checked: true }
                            break;
                    }

                    if (tmpObject) {
                        if (tmpString.length < 120) {
                            tmpsSelected[key].push(tmpObject)
                        } else {
                            if (tempBoolean) {
                                tmpsSelected[key].push(tmpObject)
                            }
                        }
                    }
                }
            }
        });

        if (type == 'showLess') {
            if (tmpString.length < 120) {
                setShowMoreFilters(true)
            } else {
                setShowMoreFilters(false)
            }
        }
        setSelectedFilters({ ...tmpsSelected })
    }

    const determineFilterKey = key => {
        let title = 'فیلتر'
        switch (key) {
            case 'brands':
                title = 'برند'
                break;
            case 'productGroups':
                title = 'گروه کالا'
                break;
            case 'channels':
                title = 'کانال'
                break;
            case 'salesStatus':
                title = 'وضعیت فروش'
                break;
            case 'hasComp':
                title = 'رقابت'
                break;
        }

        return title;
    }
    const checkIfFilterAvailable = () => {
        let result = false;
        Object.keys(selectedFilters).map((key, index) => {
            if (selectedFilters[key].length > 0) {
                result = true
            }
        })
        return result
    }

    // change route modal alert
    const [changeRouteModal, setChangeRouteModal] = useState({
        showModal: false,
        unEditedList: [],
        redirectedURL: ''
    })

    useEffect(() => {
        const unlisten = history.block((location) => {
            if (location.pathname == '/variants') {
                return true
            } else {
                if (changeRouteModal.unEditedList.length > 0 && !changeRouteModal.showModal) {
                    // show modal & set URL
                    let tmp = changeRouteModal;
                    tmp.showModal = true
                    tmp.redirectedURL = location.pathname
                    setChangeRouteModal({ ...tmp })
                    return false;
                } else {
                    return true
                }
            }
        })
        return function cleanup() {
            unlisten()
        }
    }, [])

    const isEditing = type => {
        let tmp = changeRouteModal;
        if (type == 'add') {
            tmp.unEditedList.push('a')
        }
        if (type == 'remove') {
            tmp.unEditedList.pop()
        }
        if (type == 'empty') {
            tmp.unEditedList = []
        }
        setChangeRouteModal({ ...tmp })
    }

    const [isGettingDKList, setIsGettingDKList] = useState(false)

    const updateProduct = async () => {
        setIsGettingDKList(true)
        if (filterData.channels.length > 1) {
            let modalsTemp = { ...modals };
            modalsTemp.selectedModal = 'channels';
            modalsTemp['channels'] = true;
            modalsTemp.data = { channels: filterData.channels };
            setModals(modalsTemp);

        } else {
            const res = await GetProductListFromDK({ channelId: filterData.channels[0] ? filterData.channels[0]._id : '' }, openToast);
            if (res.data.success) {
                setUpdateThreshold(30);
                intervalRef.current = setInterval(countUp, 1000);
                setchannelsModal({ show: false, selected: '' })
            }
        }
        setIsGettingDKList(false)
    }
    const updateProductServerCall = async (id) => {
        const res = await GetProductListFromDK({ channelId: id }, openToast);
        if (res.data.success) {
            setUpdateThreshold(30);
            intervalRef.current = setInterval(countUp, 1000);
            setchannelsModal({ show: false, selected: '' })
        }
    }
    const tryAgainUpdateProduct = async () => {
        setIsGettingDKList(true)
        const res = await GetProductListFromDK({ channelId: filterData.channels[0] ? filterData.channels[0]._id : '' }, openToast);
        if (res.data.success) {
            setUpdateThreshold(0);
        }
        setIsGettingDKList(false)
    }

    const sellStatusHandler = (tag, val) => {
        let tmpsSelected = { ...selectedFilters, salesStatus: [], hasComp: [] }
        if (tag == "salesStatus") {
            switch (getFromUrl("salesStatus")) {
                case "none":
                case "both":
                    setToUrl(val.name === "وضعیت فروش فعال" ? !val.checked : val.checked, "salesStatus");
                    break;
                case true:
                    setToUrl(val.name === "وضعیت فروش فعال" ? "none" : "both", "salesStatus")
                    break;
                case false:
                    setToUrl(val.name === "وضعیت فروش فعال" ? "both" : "none", "salesStatus")
                    break;
                default:
                    break;
            }

            switch (getFromUrl("salesStatus")) {
                case "both":
                    tmpsSelected.salesStatus.push({ name: 'فعال و غیر فعال', checked: true })
                    break;
                case true:
                    tmpsSelected.salesStatus.push({ name: 'فعال', checked: true })
                    break;
                case false:
                    tmpsSelected.salesStatus.push({ name: 'غیر فعال', checked: true })
                    break;
                default:
                    tmpsSelected.salesStatus = []
                    break;
            }
        }

        if (tag == 'hasComp') {
            switch (getFromUrl("hasComp")) {
                case "none":
                case "both":
                    setToUrl(val.name === "تنوع‌های دارای رقیب" ? !val.checked : val.checked, "hasComp");
                    break;
                case true:
                    setToUrl(val.name === "تنوع‌های دارای رقیب" ? "none" : "both", "hasComp")
                    break;
                case false:
                    setToUrl(val.name === "تنوع‌های دارای رقیب" ? "both" : "none", "hasComp")
                    break;
                default:
                    break;
            }

            switch (getFromUrl("hasComp")) {
                case "both":
                    tmpsSelected.hasComp.push({ name: 'تمام تنوع‌ها', checked: true })
                    break;
                case true:
                    tmpsSelected.hasComp.push({ name: "تنوع‌های دارای رقیب", checked: true })
                    break;
                case false:
                    tmpsSelected.hasComp.push({ name: "تنوع‌های بدون رقیب", checked: true })
                    break;
                default:
                    tmpsSelected.hasComp = []
                    break;
            }

        }

        console.log('2');
        setSelectedFilters({ ...tmpsSelected })
    }

    const mobileFiltersSelectHandler = (tag, value) => {
        if (tag == 'salesStatus') {
            sellStatusHandler(tag, value)
        } else {
            selectHandler(tag, value)
        }
        getVariants()
    }

    const selectHandler = (tag, value) => {
        if (tag !== 'salesStatu' && tag !== 'hasCom') {
            let filterDataTemp = { ...filterData };
            let url = getFromUrl(tag);
            if (value.checked) {
                url.splice(url.indexOf(tag === "channel" ? value._id : value.name), 1);
            } else {
                url.push(tag === "channel" ? value._id : value.name ? value.name : value)
            }
            setToUrl(url, tag);
            filterDataTemp[`${tag}s`] = urlChecker(filterDataTemp[`${tag}s`], tag);
            setFilterData(filterDataTemp);
        } else {
            let tmpSelected = selectedFilters
            if (tag == 'salesStatu') {
                if (value.checked) {
                    setToUrl('none', 'salesStatus')
                    tmpSelected.salesStatus = []
                }
            }
            if (tag == 'hasCom') {
                if (value.checked) {
                    setToUrl('none', 'hasComp')
                    tmpSelected.hasComp = []
                }
            }
            console.log('3');
            setSelectedFilters({ ...tmpSelected })
        }
    }
    const searchHandler = (tag, value) => {
        let filterDataTemp = { ...filterData };
        filterDataTemp[tag] = value;
        setFilterData(filterDataTemp);
    }
    const searcher = (searchlist, key) => {
        let searchedList = []
        if (key) {
            searchlist.map(item => {
                if (item.name.includes(key)) {
                    searchedList.push(item);
                }
            })
            return searchedList;
        } else {
            return searchlist;
        }
    }
    const urlChecker = (list, key) => {
        let tempList = [];
        let filters = getFromUrl(key);
        switch (key) {
            case "channel":
                list.map(item => {
                    if (filters.indexOf(item._id ? item._id : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: false });
                    }
                })
                break;
            case "brand":
                list.map(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, checked: false });
                    }
                })
                break;
            case "productGroup":
                list.map(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, checked: false });
                    }
                })
                break;
            default:
                break;
        }
        return tempList;
    }
    // modals logic  
    const [editVaraint, setEditVaraint] = useState({
        variantIds: [],
        variantIdsType: "none",
        variantId: "",
        variant: { productGroup: [] },
        form: {},
        table: {},
        errors: {}
    });
    const [promotionPercent, setPromotionPercent] = useState()

    const productCheckHandler = (id, isCompleted) => {
        let editVaraintTemp = { ...editVaraint };
        if (editVaraintTemp.variantIds.indexOf(id) === -1) {
            editVaraintTemp.variantIds.push(id);
            editVaraintTemp.variantIdsType = isCompleted;
        } else {
            editVaraintTemp.variantIds.splice(editVaraintTemp.variantIds.indexOf(id), 1);
            editVaraintTemp.variantIds.length === 0 ? editVaraintTemp.variantIdsType = "none" : console.log();
        }
        setEditVaraint(editVaraintTemp);
    }
    const isDisableVarint = (color) => {
        if (editVaraint.variantIdsType === "none") {
            return false;
        } else {
            if (editVaraint.variantIdsType === color) {
                return false;
            } else {
                return true;
            }
        }
    }

    const [channelsModal, setchannelsModal] = useState({ show: false, selected: '' })
    const [modals, setModals] = useState({});
    const toggleModal = async (tag, type, id) => {
        if (tag === "edit") {
            let modalsTemp = { ...modals };
            modalsTemp.selectedModal = tag;
            modalsTemp[tag] = true;
            setPromotionPercent(undefined)
            if (!modalsTemp.edit) {
                setIsCalculatingPrice(false)
            }
            let temp = []
            if (type === "one") {
                let editvariants = { ...editVaraint };

                temp.push(id);
                editvariants.variantIds = temp;
                await setEditVaraint({ ...editvariants });
            }
            await setModals(modalsTemp);
            createEditList(temp)
        } else {
            let modalsTemp = { ...modals };
            modalsTemp.selectedModal = tag;
            modalsTemp[tag] = true;
            let variant = variantList.variantList.find(item => item._id === id)
            variant.mergedVariants = [] || []
            variant && (modalsTemp.data = variant);
            setModals(modalsTemp);
        }
    }

    const createEditList = (ids) => {
        let tempVariantList = variantList.variantList
        let temp = []
        if (ids) {
            ids.forEach(item => {
                let res = tempVariantList.find(variant => variant._id === item)
                if (res) {
                    temp.push(res)
                }
            })
            setTempEditList(temp)
        }
    }

    const closeToast = () => {
        let editVaraintTemp = { ...editVaraint };
        delete editVaraintTemp.toast;
        setEditVaraint(editVaraintTemp);
    }
    const openToast = (error) => {
        if (error == "ایمیل یا رمز عبور نادرست است!") {
        } else {
            let channelId = filterData.channels[0] ? filterData.channels[0]._id : ''
            let editVaraintTemp = { ...editVaraint };
            if (error == "خطای سرور!" && channelId == '') {
                editVaraintTemp.toast = 'لطفا ابتدا پنل دیجی‌کالا خود را ثبت کنید';
            } else {
                editVaraintTemp.toast = error;
            }
            setEditVaraint(editVaraintTemp);
        }
    }

    const submitEditVariant = async (data) => {
        let tmp = offset
        let editRes = await EditSingleVariantModalCalc(data, openToast)
        if (typeof editRes !== 'undefined') {
            // await getVariants() ====> updateVariant()
            await updateVariant(data)
            // 
            window.scrollTo({
                top: tmp,
                behavior: "smooth"
            });
            // complete progressBar
            await handleProgressBar()
            // complete progressBar
        }
        return editRes
    }

    const updateVariant = async (data) => {
        let res = await GetSingleVariant(data.variantId, openToast)
        if (res) {
            let tmp = variantList
            for (let i = 0; i < tmp.variantList.length; i++) {
                if (tmp.variantList[i]._id == res._id) {
                    tmp.variantList[i] = res
                }
            }
            setVariantList({ ...tmp })
            return true
        }
        return false
    }

    const handleProgressBar = async () => {
        let local = localStorage.getItem('progressBar')
        if (typeof local !== 'undefined' && local != null) {
            let res = await GetProgressBar()
            if (res && res.data && res.data.success) {
                let tmpLocal = res.data.progressData.progressBar
                if (!tmpLocal.AddRobot) {
                    await CompleteProgressBar({ stage: 'AddRobot' })
                }
            }
        }
    }

    const CalculateEdit = async (data) => {
        let dummyObject = {
            data: {
                price: {
                    data: {
                        maxProfit: {
                            sellPrice: 0
                        },
                        minProfit: {
                            sellPrice: 0
                        }
                    }
                }
            }
        }
        let editRes = await CalcPrice(data, openToast)
        return editRes ? editRes : dummyObject
    }

    const timeCalc = (remainTime) => {
        let min = Math.floor((remainTime - progressbar.timer) / 60);
        let second = Math.floor((remainTime - progressbar.timer) % 60);
        if (Math.floor(remainTime - progressbar.timer) <= 0) {
            return toPersianNumber("00") + ":" + toPersianNumber("00")
        } else {
            return toPersianNumber(min.toString().length === 1 ? "0" + min : min) + ":" + toPersianNumber(second.toString().length === 1 ? "0" + second : second)
        }
    }

    const closeVariantModal = async (tag) => {
        let tmp = offset
        let modalsTemp = { ...modals };
        modalsTemp.selectedModal = '';
        modalsTemp.data = {}
        modalsTemp[tag] = false;
        setModals(modalsTemp);
        closeToast()
        if (tag == 'submited') {
            await getVariants()
            window.scrollTo({
                top: tmp,
                behavior: "smooth"
            });
        }
    }

    const addChannel = async (email, password) => {
        let params = { username: toEnglishNumber(email), password: toEnglishNumber(password) };
        let res = await SubmitAddChannel(params)
        setEditModal({ ...editModal, show: false })
        await getVariants()
        return res;
    }


    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <React.Fragment>
                <EditChannelModal
                    show={editModal.show}
                    closemodal={() => setEditModal({ ...editModal, show: false })}
                    email=''
                    editchannel={addChannel}
                />
                <Toast
                    tag="checkError"
                    value={editVaraint.toast}
                    text={editVaraint.toast}
                    parentClose={closeToast}
                />
                <SuccessToast
                    tag="successToast"
                    type={successToast.type}
                    value={successToast.value}
                    text={successToast.text}
                    parentClose={() => setSuccessToast({ value: false, text: '', type: 'success' })}
                />
                <EditModal
                    list={tempEditList}
                    show={modals.selectedModal === 'edit'}
                    accountId={props.user.account._id}
                    closeModal={closeVariantModal}
                />
                <ImportVariantModal
                    show={importData}
                    closeModal={() => {
                        setImportData(false);
                        getVariants();
                    }}
                />
                <ChangeRouteModal
                    value={changeRouteModal.showModal}
                    title={'ویرایش تنوع'}
                    parentClose={() => setChangeRouteModal({ ...changeRouteModal, showModal: false })}
                    unEditedLength={changeRouteModal.unEditedList}
                    buttonLabel={"بازگشت به صفحه لیست تنوع‌ها"}
                    urlDirect={changeRouteModal.redirectedURL}
                    emptyEditedList={() => isEditing('empty')}
                />
                <div className={style.wrapper}>
                    {
                        props.user.expiredAccount && <div className={style.gradientWrapper}>
                            <GradientToast tag="test" value={true}>
                                <>
                                    <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                    <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                    <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                                </>
                            </GradientToast>
                        </div>
                    }
                    {
                        props.user.disconnected.status &&
                        <div className={style.gradientWrapper}>
                            <GradientToast tag="test" value={true}>
                                <>
                                    <p className={style.expiredTitle}>{disconnectTextGenerator(props.user.disconnected.channelName)}</p>
                                    <p className={style.expiredText}>جهت اتصال دوباره موبیشا به پنل، لطفا اطلاعات خود را در صفحه پنل دیجی‌کالا به‌روز رسانی کنید</p>
                                    <Link className={style.expiredLink} to={'/channels'}>ورود به صفحه‌ی  پنل دیجی‌کالا  </Link>
                                </>
                            </GradientToast>
                        </div>
                    }

                    {/*<div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <GeneralWarning />
                        </GradientToast>
                    </div>*/}

                    <div className={style.variantModalWrapper}>
                        <VariantModalRenderer
                            tag={modals.selectedModal}
                            value={modals.selectedModal == "channels"}
                            title={"انتخاب فروشنده"}
                            data={modals.data}
                            confirmFunction={updateProductServerCall}
                            refresh={() => getVariants()}
                            closeParent={closeVariantModal}
                        />
                    </div>

                    {typeof (progressbar.AllVariantsCount) === "undefined" ?
                        <div className={style.headerWrapper}></div>
                        :
                        <React.Fragment>
                            <div className={style.headerWrapper}>
                                {progressbar.percent < 100 && progressbar.remainTime !== 0 ?
                                    filterData.channels.length > 0 && progressbar.AllVariantsCount > 0 ?
                                        <div className={style.progressbarwrapperDown}>
                                            <div className={style.row}>
                                                <Progressbar width={parseInt(progressbar.percent)} />
                                                <div className={style.time}>{timeCalc(progressbar.remainTime)}</ div>
                                            </div>
                                            <div className={style.textRow}>
                                                <p className={style.text}>
                                                    {toPersianNumber(progressbar.receivedVariantsCount)}
                                                    {" "} کالا از{" "}
                                                    {toPersianNumber(progressbar.AllVariantsCount)}
                                                    {" "}کالا دریافت شد.{" "}
                                                </p>
                                            </div>
                                            {progressbar.isActiveButton ?
                                                <div style={{ maxWidth: "145px" }}>
                                                    <Button
                                                        type="solid"
                                                        disabled={isGettingDKList ? true : false}
                                                        label={progressbar.isActiveButton ? "تلاش مجدد" : "به‌روز رسانی تنوع‌ها از دیجی‌کالا"}
                                                        onclick={progressbar.isActiveButton ? tryAgainUpdateProduct : updateProduct} />

                                                </div>
                                                : null}
                                        </div>
                                        : <div className={style.progressbarwrapperDown}></div>
                                    : <div className={style.headerButtonWrapper}>
                                        <div className={style.buttonContainer}>
                                            <Button
                                                type="solid"
                                                label={"به‌روز رسانی تنوع‌ها از دیجی‌کالا"}
                                                disabled={isGettingDKList ? true : false}
                                                onclick={updateProduct} />
                                        </div>
                                        <div className={style.buttonContainerExcel}>
                                            <Button
                                                type="outline"
                                                label="تکمیل اطلاعات با اکسل"
                                                onclick={() => {
                                                    setImportData(true)
                                                }} />
                                        </div>
                                    </div>
                                }
                                <h3>تنوع‌ها</h3>
                            </div>

                            {!variantList.hasChannel && variantList.variantList.length < 1 ?
                                <div className={style.empty}>
                                    {filterData.channels.length > 0 ?
                                        <React.Fragment>
                                            <div className={style.image}>
                                                <img src={noVariantEmptyState} />
                                            </div>
                                            <p>اینجا همه‌ی تنوع‌هایی که دارید رو می‌بینید و می‌تونید با تکمیل اطلاعات، ربات رو براشون فعال کنید</p>
                                            <p className={style.boldText}>برای شروع لیست کالاها رو به‌روز رسانی کنید</p>
                                            <Button type="solid"
                                                label={"به‌روز رسانی تنوع‌ها از دیجی‌کالا"}
                                                onclick={updateProduct} />
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <div className={style.image}>
                                                <img src={noChannelEmptyState} />
                                            </div>
                                            <p>اینجا همه‌ی تنوع‌هایی که دارید رو می‌بینید و می‌تونید با تکمیل اطلاعات، ربات رو براشون فعال کنید</p>
                                            <p className={style.boldText}>برای شروع پنل دیجی‌کالا رو ثبت کنید</p>
                                            <div className={style.addPannelButtonWrapper}>
                                                <Button type="solid"
                                                    label={"ثبت پنل جدید"}
                                                    onclick={() => props.history.push("/channels")}
                                                // onclick={() => setEditModal({ ...editModal, show: true })} 
                                                />
                                                <Button type="noBorder"
                                                    label={"ورود به صفحه پنل دیجی کالا"}
                                                    onclick={() => props.history.push("/channels")}
                                                />
                                            </div>

                                        </React.Fragment>
                                    }

                                </div>
                                :
                                progressbar.receivedVariantsCount < 100 && progressbar.receivedVariantsCount !== progressbar.AllVariantsCount ?
                                    <div className={style.empty}>
                                        <div className={style.image}>
                                            <img src={noVariantEmptyState} />
                                        </div>
                                        <p>.کاربر عزیز، در حال حاضر شما هیچ کالایی در ربات موبیشا ندارید</p>
                                        <p className={style.boldText}>. لیست کالاهای شما درحال بروز رسانی از دیجی‌کالا میباشد </p>
                                        <div className={style.progressbarwrapperDown}>
                                            <Progressbar width={parseInt(progressbar.percent)} />
                                            <div className={style.textRow}>
                                                <p className={style.text}>
                                                    {toPersianNumber(progressbar.receivedVariantsCount)}
                                                    {" "} کالا از{" "}
                                                    {toPersianNumber(progressbar.AllVariantsCount)}
                                                    {" "}کالا دریافت شد.{" "}
                                                </p></div>
                                            < div className={style.time}>{timeCalc(progressbar.remainTime)}</ div>
                                        </div>
                                    </div>
                                    : <React.Fragment>
                                        <div className={style.searchbarWrapper}>
                                            <Searchbar
                                                placeholder={"عنوان یا کد کالا یا کد تنوع"}
                                                value={getFromUrl("query") ? getFromUrl("query") : ""}
                                                tag="query"
                                                searchValue={setToUrl}
                                            />
                                        </div>

                                        {/* Filters Wrapper */}
                                        <div className={style.desktopFilters}>
                                            <FiltersWrapper
                                                checkUrl={checkUrl}
                                                deleteAllFiletrs={deleteAllFiletrs}
                                                getFromUrl={getFromUrl}
                                                deleteFromUrl={deleteFromUrl}
                                                filterData={filterData}
                                                getVariants={getVariants}
                                                setToUrl={setToUrl}
                                                searcher={searcher}
                                                sellStatusHandler={sellStatusHandler}
                                                selectHandler={selectHandler}
                                                searchHandler={searchHandler}
                                            />
                                        </div>

                                        <div className={style.mobileFilters}>
                                            <MobileFilters
                                                filterData={Object.assign(filterData,
                                                    { salesStatus: [{ name: "وضعیت فروش فعال", checked: getFromUrl("salesStatus") === "both" || getFromUrl("salesStatus") === true ? true : false }, { name: "وضعیت فروش غیرفعال", checked: getFromUrl("salesStatus") === "both" || getFromUrl("salesStatus") === false ? true : false }] },
                                                    { hasComp: [{ name: "تنوع‌های دارای رقیب", checked: getFromUrl("hasComp") === "both" || getFromUrl("hasComp") === true ? true : false }, { name: "تنوع‌های بدون رقیب", checked: getFromUrl("hasComp") === "both" || getFromUrl("hasComp") === false ? true : false }] }
                                                )}
                                                FilterArrays={[{ name: 'وضعیت فروش', tag: 'salesStatus' }, { name: 'گروه کالا', tag: 'productGroup' }, { name: 'برند', tag: 'brand' }, { name: 'رقابت', tag: 'hasComp' }, { name: 'فروشنده', tag: 'channel' }]}
                                                selectHandler={mobileFiltersSelectHandler}
                                                getFromUrl={getFromUrl}
                                                setToUrl={setToUrl}
                                                isFiltersSelected={Object.keys(selectedFilters).map(el => { if (selectedFilters[el].length > 0) { return true } else { return false } })}
                                                switchFilter={{ incompleteProducts: { name: 'کالاهای تکمیل نشده در ربات', checked: getFromUrl('incompleteProducts') } }}
                                            />
                                        </div>
                                        {/* Filters Wrapper */}

                                        {/* show Filters */}
                                        <div
                                            className={style.dropdownWrapperFilters}
                                            ref={divHeight}
                                        >
                                            {Object.keys(selectedFilters).map((selectedFilter, index) => <React.Fragment key={`selectedFilter_${index}`}>
                                                {selectedFilters[selectedFilter].length > 0 ? <>
                                                    {selectedFilters[selectedFilter].map((item, key) => <div
                                                        className={style.singleKeyItem}
                                                        key={`item_${key}`}
                                                    >
                                                        <p>{determineFilterKey(selectedFilter)}: {item.name}</p>
                                                        <span
                                                            onClick={() => { selectHandler(selectedFilter.slice(0, -1), item); getVariants() }}
                                                        >e</span>
                                                    </div>)}
                                                </>
                                                    :
                                                    null}
                                            </React.Fragment>)}

                                            <div className={style.moreInfoWrapper}>
                                                {!showMoreFilters && checkIfFilterAvailable() ? <p
                                                    className={style.showMore}
                                                    onClick={() => setShowFilters('showMore')}
                                                >
                                                    نمایش بیشتر
                                                </p> : null}
                                                {checkIfFilterAvailable() ? <p
                                                    className={style.filterRemover}
                                                    onClick={() => deleteAllFiletrs()}
                                                >
                                                    حذف همه فیلترها
                                                </p> : null}
                                            </div>
                                        </div>
                                        {/* show Filters */}

                                        {variantList.variantCount === 0 && variantList.hasProduct ?
                                            <div className={style.emptySearch}>
                                                <div className={style.image}>
                                                    <img src={noResultEmptyState} />
                                                </div>
                                                <p className={style.bolderText}>!نتیجه‌ای یافت نشد</p>
                                                <p className={style.mediumText}>لطفا عبارت دیگری جستجو کنید</p>
                                                <p className={style.grayText}>درصورت اطمینان از وجود این تنوع در دیجی‌کالا، تنوع‌ها را به‌روز رسانی کنید</p>
                                                <div className={style.addPannelButtonWrapper}>
                                                    <Button type='solid' label='بازگشت' onclick={() => props.history.goBack()} />
                                                    <Button type='noBorder' label='به‌روز رسانی تنوع‌ها از دیجی‌کالا' onclick={() => updateProduct} />
                                                </div>
                                            </div>
                                            :
                                            !variantList.hasProduct && variantList.variantCount === 0 ?
                                                (<div className={style.emptySearch}>
                                                    <div className={style.image}>
                                                        <img src={noVariantEmptyState} />
                                                    </div>
                                                    <p className={style.bolderText}>.کاربر عزیز، در حال حاضر شما هیچ کالایی در دیجی‌کالا ندارید</p>
                                                    <p className={style.mediumText}>لطفا نسبت به افزودن محصولات خود در پنل دیجی‌کالا اقدام کنید</p>
                                                    <p className={style.grayText}>درصورت اطمینان از وجود محصول در دیجی‌کالا، تنوع‌ها را به‌روز رسانی کنید</p>
                                                    <div className={style.addPannelButtonWrapper}>
                                                        <Button type='solid' label='بازگشت' onclick={() => props.history.goBack()} />
                                                        <Button type='noBorder' label='به‌روز رسانی تنوع‌ها از دیجی‌کالا' onclick={() => updateProduct} />
                                                    </div>
                                                </div>)
                                                :
                                                (<div className={style.cardComponents}>
                                                    <div className={style.pagination}>
                                                        <div className={style.Dropdown}>
                                                            <Pagination
                                                                tag="page"
                                                                currentPage={parseInt(getFromUrl("page"))}
                                                                pageCount={variantList.variantListPageCount}
                                                                setPage={setToUrl} />

                                                            <TinyDropdown
                                                                placeholder={10}
                                                                dropdownList={["10", "25", "50", "75", "100"]}
                                                                selected={selected => {
                                                                    setToUrl(selected, 'countInPage')
                                                                }}
                                                                selectedItem={getFromUrl('countInPage')}
                                                            />
                                                            <div className={style.label}>تعداد نمایش در صفحه</div>
                                                            <div className={style.verticalLine}></div>
                                                            <div
                                                                className={style.variantCount}>{typeof variantList.variantCount !== 'undefined' ? toPersianNumber(variantList.variantCount) + " تنوع" : ""}</div>
                                                        </div>
                                                    </div>

                                                    {/* Variant List Table */}
                                                    <div className={style.desktop}>
                                                        <div className={style.hiddenListShadow}></div>
                                                        <div className={style.listWrapper}>
                                                            <div
                                                                style={offset > 480 && (sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? { width: 'calc(100% - 140px)' } : (offset > 480 ? { width: 'calc(100% - 280px)' } : null)}
                                                                className={offset > 480 ? style.listHeaderShadowFixed : style.listHeaderShadow}
                                                            >
                                                                <div className={style.listHeader}>
                                                                    <div className={style.listHeaderFlexItem303}>مشخصات کالا</div>
                                                                    <div className={style.listHeaderFlexItem51}>وضعیت فروش</div>
                                                                    <div className={style.listHeaderFlexItem124}>قیمت خرید<span>(ریال)</span></div>
                                                                    <div className={style.listHeaderFlexItem347}>حداقل حاشیه سود</div>
                                                                    <div className={style.listHeaderFlexItem32}></div>
                                                                </div>
                                                            </div>

                                                            <div className={style.listHeader}></div>

                                                            {variantList.variantList.map((item, index) => {
                                                                return <div key={index}>
                                                                    <VariantWrapper
                                                                        keys={index}
                                                                        data={{ ...item }}
                                                                        channelList={filterData.channels}
                                                                        disabled={isDisableVarint(item.robot === null ? "red" : "green")}
                                                                        checked={editVaraint.variantIds.indexOf(item._id) === -1 ? false : true}
                                                                        threeDotHandler={(tag, type, id) => toggleModal(tag, type, id)}
                                                                        productChecked={productCheckHandler}
                                                                        isEditing={isEditing}
                                                                        SubmitEdit={submitEditVariant}
                                                                        CalculateEdit={CalculateEdit}
                                                                    />
                                                                </div>
                                                            })}
                                                        </div>
                                                    </div>

                                                    <div className={style.mobile}>
                                                        {variantList.variantList.map((item, index) => {
                                                            return <React.Fragment key={index}>
                                                                <MobileVariantCard
                                                                    keys={index}
                                                                    data={{ ...item }}
                                                                    channelList={filterData.channels}
                                                                    disabled={isDisableVarint(item.robot === null ? "red" : "green")}
                                                                    checked={editVaraint.variantIds.indexOf(item._id) === -1 ? false : true}
                                                                    threeDotHandler={(tag, type, id) => toggleModal(tag, type, id)}
                                                                    productChecked={productCheckHandler}
                                                                    isEditing={isEditing}
                                                                    SubmitEdit={submitEditVariant}
                                                                    CalculateEdit={CalculateEdit}
                                                                />
                                                            </React.Fragment>
                                                        })}
                                                    </div>
                                                    {/* Variant List Table */}
                                                    <div className={style.mobilePagination}>
                                                        <MobilePagination
                                                            tag="page"
                                                            currentPage={parseInt(getFromUrl("page"))}
                                                            pageCount={variantList.variantListPageCount}
                                                            setPage={pageSetter}
                                                        />
                                                    </div>
                                                    <div className={style.paginationTwo}>
                                                        <Pagination
                                                            tag="page"
                                                            currentPage={parseInt(getFromUrl("page"))}
                                                            pageCount={variantList.variantListPageCount}
                                                            setPage={setToUrl}
                                                        />
                                                    </div>
                                                </div>)}
                                    </React.Fragment>
                            }
                        </React.Fragment>}
                </div >
            </React.Fragment >
        )
    }
}

export default withRouter(VariantList);